
export const jobCategories = [
  'All',
  'Government',
  'Healthcare',
  'Technology',
  'Education',
  'Retail',
  'Finance',
  'Manufacturing'
];

export const jobListings = [
  {
    id: 1,
    title: 'Senior Software Engineer',
    company: 'Hewlett Packard Enterprise',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$120,000 - $160,000',
    category: 'Technology',
    posted: '2 days ago',
    description: 'Join our innovative team developing cutting-edge enterprise solutions. Work with cloud technologies, microservices, and modern development practices.',
    requirements: ['5+ years experience', 'Python/Java', 'Cloud platforms', 'Agile methodology'],
    benefits: ['Health insurance', '401(k) matching', 'Remote flexibility', 'Stock options'],
    featured: true,
    logo: 'https://public.readdy.ai/ai/img_res/083731a96437971f5ac18cba49295a5f.jpg'
  },
  {
    id: 2,
    title: 'Registered Nurse - ICU',
    company: 'Sutter Roseville Medical Center',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$85,000 - $110,000',
    category: 'Healthcare',
    posted: '1 day ago',
    description: 'Provide exceptional patient care in our state-of-the-art ICU facility. Join a team dedicated to excellence in healthcare.',
    requirements: ['RN License', 'BLS/ACLS certified', '2+ years ICU experience', 'Critical care skills'],
    benefits: ['Medical/dental/vision', 'Tuition reimbursement', 'Retirement plan', 'Sign-on bonus'],
    featured: true,
    logo: 'https://readdy.ai/api/search-image?query=Hospital%20medical%20center%20logo%20clean%20design%20red%20cross%20healthcare%20symbol%20professional&width=100&height=100&seq=joblogo002&orientation=squarish'
  },
  {
    id: 3,
    title: 'City Planner',
    company: 'City of Roseville',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$75,000 - $95,000',
    category: 'Government',
    posted: '3 days ago',
    description: 'Shape the future of Roseville through strategic urban planning. Review development proposals and ensure sustainable city growth.',
    requirements: ['Urban Planning degree', '3+ years experience', 'GIS proficiency', 'Public speaking'],
    benefits: ['CalPERS pension', 'Health benefits', 'Paid holidays', 'Work-life balance'],
    featured: true,
    logo: 'https://readdy.ai/api/search-image?query=City%20government%20seal%20logo%20official%20municipal%20emblem%20professional%20design%20gold%20and%20navy&width=100&height=100&seq=joblogo003&orientation=squarish'
  },
  {
    id: 4,
    title: 'High School Math Teacher',
    company: 'Roseville Joint Union High School District',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$58,000 - $92,000',
    category: 'Education',
    posted: '5 days ago',
    description: 'Inspire the next generation of mathematicians. Teach algebra, geometry, and calculus to high school students in a supportive environment.',
    requirements: ['Teaching credential', 'Math degree', 'Classroom experience', 'Student-focused'],
    benefits: ['Summer break', 'Pension plan', 'Health insurance', 'Professional development'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=School%20district%20education%20logo%20academic%20emblem%20book%20and%20graduation%20cap%20design%20professional&width=100&height=100&seq=joblogo004&orientation=squarish'
  },
  {
    id: 5,
    title: 'Financial Analyst',
    company: 'SAFE Credit Union',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$70,000 - $90,000',
    category: 'Finance',
    posted: '4 days ago',
    description: 'Analyze financial data and provide insights to drive strategic decisions. Support budgeting, forecasting, and financial reporting.',
    requirements: ['Finance/Accounting degree', 'Excel expertise', 'Analytical skills', 'CFA preferred'],
    benefits: ['Competitive salary', '401(k)', 'Profit sharing', 'Career growth'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=Credit%20union%20bank%20logo%20professional%20financial%20institution%20design%20green%20and%20white%20modern&width=100&height=100&seq=joblogo005&orientation=squarish'
  },
  {
    id: 6,
    title: 'Store Manager',
    company: 'Westfield Galleria at Roseville',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$55,000 - $75,000',
    category: 'Retail',
    posted: '1 week ago',
    description: 'Lead a dynamic retail team at one of Northern California\'s premier shopping destinations. Drive sales and deliver exceptional customer experiences.',
    requirements: ['Retail management experience', 'Leadership skills', 'Sales driven', 'Customer service'],
    benefits: ['Employee discounts', 'Health benefits', 'Bonus potential', 'Career advancement'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=Shopping%20mall%20retail%20center%20logo%20modern%20elegant%20design%20shopping%20bag%20icon%20professional&width=100&height=100&seq=joblogo006&orientation=squarish'
  },
  {
    id: 7,
    title: 'Production Supervisor',
    company: 'Jelly Belly Candy Company',
    location: 'Fairfield, CA (Near Roseville)',
    type: 'Full-time',
    salary: '$65,000 - $80,000',
    category: 'Manufacturing',
    posted: '6 days ago',
    description: 'Oversee candy production operations ensuring quality and efficiency. Lead a team of production workers in a fun, fast-paced environment.',
    requirements: ['Manufacturing experience', 'Team leadership', 'Quality control', 'Safety focused'],
    benefits: ['Free candy!', 'Health insurance', '401(k)', 'Paid time off'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=Candy%20manufacturing%20company%20logo%20colorful%20fun%20design%20jelly%20bean%20icon%20playful%20professional&width=100&height=100&seq=joblogo007&orientation=squarish'
  },
  {
    id: 8,
    title: 'Police Officer',
    company: 'Roseville Police Department',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$72,000 - $105,000',
    category: 'Government',
    posted: '2 weeks ago',
    description: 'Serve and protect the Roseville community. Join one of California\'s most respected police departments with excellent training and support.',
    requirements: ['POST certification', 'Physical fitness', 'Clean background', 'Community oriented'],
    benefits: ['CalPERS pension', 'Health/dental/vision', 'Paid training', 'Career advancement'],
    featured: true,
    logo: 'https://readdy.ai/api/search-image?query=Police%20department%20badge%20logo%20official%20law%20enforcement%20emblem%20shield%20design%20gold%20and%20blue&width=100&height=100&seq=joblogo008&orientation=squarish'
  },
  {
    id: 9,
    title: 'Data Scientist',
    company: 'Oracle',
    location: 'Rocklin, CA (Near Roseville)',
    type: 'Full-time',
    salary: '$130,000 - $170,000',
    category: 'Technology',
    posted: '3 days ago',
    description: 'Apply machine learning and statistical analysis to solve complex business problems. Work with big data and cutting-edge AI technologies.',
    requirements: ['MS/PhD in Data Science', 'Python/R', 'Machine learning', 'SQL expertise'],
    benefits: ['Competitive salary', 'Stock options', 'Remote work', 'Learning budget'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=Enterprise%20software%20company%20logo%20modern%20tech%20design%20red%20and%20white%20professional%20corporate&width=100&height=100&seq=joblogo009&orientation=squarish'
  },
  {
    id: 10,
    title: 'Physical Therapist',
    company: 'Kaiser Permanente',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$90,000 - $115,000',
    category: 'Healthcare',
    posted: '1 week ago',
    description: 'Help patients recover and improve mobility through personalized treatment plans. Work in a collaborative healthcare environment.',
    requirements: ['DPT degree', 'CA PT license', 'Patient care experience', 'Communication skills'],
    benefits: ['Comprehensive benefits', 'Pension plan', 'Continuing education', 'Work-life balance'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=Healthcare%20organization%20logo%20medical%20symbol%20clean%20design%20professional%20blue%20and%20white&width=100&height=100&seq=joblogo010&orientation=squarish'
  },
  {
    id: 11,
    title: 'Parks Maintenance Worker',
    company: 'City of Roseville Parks Department',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$42,000 - $55,000',
    category: 'Government',
    posted: '4 days ago',
    description: 'Maintain Roseville\'s beautiful parks and recreation facilities. Perform landscaping, equipment maintenance, and facility upkeep.',
    requirements: ['Landscaping experience', 'Equipment operation', 'Physical stamina', 'Team player'],
    benefits: ['City benefits', 'Pension', 'Outdoor work', 'Job stability'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=Parks%20and%20recreation%20department%20logo%20tree%20and%20sun%20design%20green%20nature%20professional%20municipal&width=100&height=100&seq=joblogo011&orientation=squarish'
  },
  {
    id: 12,
    title: 'Elementary School Principal',
    company: 'Roseville City School District',
    location: 'Roseville, CA',
    type: 'Full-time',
    salary: '$115,000 - $140,000',
    category: 'Education',
    posted: '2 weeks ago',
    description: 'Lead an elementary school community with vision and excellence. Foster a positive learning environment for students and staff.',
    requirements: ['Administrative credential', 'Leadership experience', 'Education background', 'Community builder'],
    benefits: ['Competitive salary', 'Comprehensive benefits', 'Summer schedule', 'Impact community'],
    featured: false,
    logo: 'https://readdy.ai/api/search-image?query=Elementary%20school%20district%20logo%20children%20education%20design%20colorful%20professional%20academic%20emblem&width=100&height=100&seq=joblogo012&orientation=squarish'
  }
];

export const employmentStats = {
  totalJobs: '15,000+',
  avgSalary: '$78,500',
  unemploymentRate: '3.2%',
  topEmployers: 4
};

export const topEmployers = [
  {
    name: 'Hewlett Packard Enterprise',
    employees: '3,500+',
    industry: 'Technology',
    logo: 'https://readdy.ai/api/search-image?query=Tech%20company%20headquarters%20building%20modern%20architecture%20glass%20and%20steel%20professional%20corporate&width=400&height=250&seq=employer001&orientation=landscape'
  },
  {
    name: 'Sutter Health',
    employees: '2,800+',
    industry: 'Healthcare',
    logo: 'https://readdy.ai/api/search-image?query=Modern%20hospital%20medical%20center%20building%20exterior%20professional%20healthcare%20facility%20architecture&width=400&height=250&seq=employer002&orientation=landscape'
  },
  {
    name: 'City of Roseville',
    employees: '1,200+',
    industry: 'Government',
    logo: 'https://readdy.ai/api/search-image?query=City%20hall%20government%20building%20classical%20architecture%20professional%20municipal%20center%20exterior&width=400&height=250&seq=employer003&orientation=landscape'
  },
  {
    name: 'Roseville Joint Union HSD',
    employees: '1,500+',
    industry: 'Education',
    logo: 'https://readdy.ai/api/search-image?query=Modern%20high%20school%20campus%20building%20exterior%20education%20facility%20professional%20architecture&width=400&height=250&seq=employer004&orientation=landscape'
  }
];

export const careerResources = [
  {
    title: 'Resume Workshop',
    description: 'Free monthly workshops at Roseville Library to help polish your resume',
    icon: 'ri-file-text-line',
    link: '#'
  },
  {
    title: 'Job Fairs',
    description: 'Quarterly job fairs connecting local employers with job seekers',
    icon: 'ri-group-line',
    link: '#'
  },
  {
    title: 'Skills Training',
    description: 'Partner programs with Sierra College for career development',
    icon: 'ri-graduation-cap-line',
    link: '#'
  },
  {
    title: 'Career Counseling',
    description: 'One-on-one guidance from employment specialists',
    icon: 'ri-user-voice-line',
    link: '#'
  }
];
